import { render, staticRenderFns } from "./help-page.component.vue?vue&type=template&id=697ac164&"
import script from "./help-page.component.vue?vue&type=script&lang=ts&"
export * from "./help-page.component.vue?vue&type=script&lang=ts&"
import style0 from "./help-page.component.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports